var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"python-home"},[_c('navBarNoLab',{attrs:{"onIndex":3}}),_c('pythonBackGround',{attrs:{"backGroundCom":_vm.backGroundComInfo},scopedSlots:_vm._u([{key:"navList",fn:function(){return [_c('pageElement',{attrs:{"onIndex":3}})]},proxy:true}])}),_c('manyAspect'),_c('developStandard'),_c('occupatChoice'),_c('bottomWidge')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }